import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { registerStart, registerSuccess, registerFailure } from '../redux/authSlice';
import axios from 'axios';

const Register = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [lname, setLName] = useState('');
  const [mobile, setMobile] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(registerStart());

    try {
      const formData = {
        firstname : name,
        lastname : lname,
        email : email,
        mobile : mobile,
        password : password
      };
      const response = await axios.post(`${apiBaseUrl}register`, formData);
      console.log(response);
      if(response.data.type == 'error'){
        setErrorMsg(response.data.message);
      }
      else{
        dispatch(registerSuccess(response.data));
      }
      loading = false;
    } catch (err) {
      dispatch(registerFailure(err.response?.data?.message || 'Something went wrong'));
    }
  };

  return (
    <div className='container'>
      <div className='row text-center mb-3'>
        <h3>REGISTER</h3>
      </div>
      <form onSubmit={handleSubmit}>
         <div className='row'>
          <div className='col-md-6 mb-3'>
            <label>First Name</label>
            <input
              type="text"
              placeholder="First Name"
              value={name}
              className='form-control'
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className='col-md-6 mb-3'>
            <label>Last Name</label>
            <input
              type="text"
              placeholder="Last Name"
              value={lname}
              className='form-control'
              onChange={(e) => setLName(e.target.value)}
              required
            />
          </div>
          <div className='col-md-12 mb-3'>
            <label>Mobile</label>
            <input
              type="tel"
              placeholder="Mobile"
              className='form-control'
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              required
            />
          </div>
          <div className='col-md-12 mb-3'>
            <label>Email</label>
            <input
              type="email"
              placeholder="Email"
              className='form-control'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className='col-md-12 mb-3'>
            <label>Password</label>
            <input
              type="password"
              placeholder="Password"
              className='form-control'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {errorMsg && <p className='text-danger'>{errorMsg}</p>}
          <div className='col-12 text-center'>
            <button type="submit" className='btn btn-outline-success' disabled={loading}>
            {loading ? 'Registering...' : 'Register'}
          </button>
          </div>
         </div>
      </form>
      {/* {error && <p>{error}</p>} */}
    </div>
  );
};

export default Register;
